export const API_BASE_URL: string = import.meta.env.VITE_API_BASE_URL;

if (!API_BASE_URL) throw new Error('VITE_API_BASE_URL is required');
